"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonasSaveControls = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
/**
 * Header strip that pairs the Save / Discard buttons with the page
 * description. Pure presentational — kept tiny so the same pattern can
 * be reused by other AI Hub admin tabs.
 */
exports.PersonasSaveControls = function (_a) {
    var title = _a.title, description = _a.description, hasChanges = _a.hasChanges, onSave = _a.onSave, onDiscard = _a.onDiscard;
    return (react_1.default.createElement("div", { className: "ws-tab-header" },
        react_1.default.createElement("div", { className: "ws-header-row" },
            react_1.default.createElement("div", { className: "ws-header-left" },
                react_1.default.createElement("div", { className: "ws-save-controls" },
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "small", className: "ws-save-controls-label" }, title),
                    react_1.default.createElement("div", { className: "ws-save-controls-row" },
                        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Save' }, text: "Save Changes", className: "ws-admin-button-filled-primary", disabled: !hasChanges, onClick: onSave }),
                        react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Undo' }, title: "Discard Changes", ariaLabel: "Discard Changes", className: "ws-admin-button-neutral-icon", disabled: !hasChanges, onClick: onDiscard })))),
            react_1.default.createElement("div", { className: "ws-header-right" },
                react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "medium", className: "ws-page-description" }, description)))));
};
